import RSLogo from "../icons/RSLogo";
import {
  Calendar,
  Clock,
  Exclamation,
  ExclamationCircle,
} from "../icons/svg/outline";

/**
 * Render an announcement icon by stored key.
 *
 * @param {Object} props Component props.
 * @param {string} [props.icon="rs"] Stored icon key.
 * @param {string} [props.className] Extra classes on the outline SVGs.
 * @returns {JSX.Element} Icon for the announcement card or picker.
 */
const AnnouncementIcon = ({ icon = "rs", className = "h-5 w-5" }) => {
  if (icon === "rs") {
    return <RSLogo classes="h-9 w-9" variant="logo_trans_fill" alt="" />;
  }

  const Icon =
    {
      circle: ExclamationCircle,
      triangle: Exclamation,
      clock: Clock,
      calendar: Calendar,
    }[icon] || ExclamationCircle;

  return <Icon className={className} />;
};

export default AnnouncementIcon;
